import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporateoutingmorachichincholi() {



    const cardData =
    {
        keyword: 'Corporate Outing Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Corporate Outing Morachi Chincholi Pune',
        headingDescription: 'Planning a unique and refreshing corporate outing Morachi Chincholi Pune? Anand Krushi Paryatan Kendra, just 55 km from Pune, offers the perfect blend of team bonding, nature, and traditional village experiences on its scenic 40-acre agri-tourism farm. Designed for stress-free corporate getaways, the destination provides activities that foster relaxation and collaboration—bullock cart and tractor rides, boating, swimming, horse riding, and a lively rain dance zone. Teams can also enjoy puppet shows, magic shows, and engage in traditional games that bring out team spirit in a fun rural setting.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Team Tractor Safari",
    "description": "Begin the day with a refreshing tractor ride through Morachi Chincholi’s scenic farmland. This group-friendly activity lets teams bond as they soak in countryside views, waving mustard fields, and morning peacocks. Great for breaking the ice before a full day of fun."
  },
  {
    "title": "Interactive Farming Tour",
    "description": "Colleagues can join hands-on farming activities such as planting, watering, and harvesting seasonal produce. Guided by local farmers, these tours promote team interaction while highlighting sustainability, organic methods, and rural innovation."
  },
  {
    "title": "Traditional Maharashtrian Lunch",
    "description": "Gather together under a shaded pavilion for an unlimited thali served on banana leaves—featuring dishes like pithla, zunka-bhakar, varan-bhat, and fresh curd. The farm-to-table meal experience encourages slow dining and team bonding."
  },
  {
    "title": "Team Building Games",
    "description": "Engage in group activities like sack races, tug-of-war, lagori, kho-kho, and kabaddi on large open grounds. These traditional games provide joyful moments of laughter, teamwork, and healthy competition among coworkers."
  },
  {
    "title": "Adventure Rope & Obstacle Zone",
    "description": "Challenge your team with zip-lines, rope ladders, balance bridges, and more. This fun-filled obstacle course is ideal for team building, trust exercises, and cheering each other on in a natural, rustic setting."
  },
  {
    "title": "Peacock Watching & Nature Trails",
    "description": "Take a relaxing stroll through lush trails, bamboo groves, and village paths with the chance to spot free-roaming peacocks and native birds. A perfect post-lunch detox for reflection and mindfulness."
  },
  {
    "title": "Rain Dance & Splash Pool Fun",
    "description": "Turn up the energy with DJ-powered rain dance and splash pools. Whether it’s grooving to Bollywood beats or relaxing in the water, this is a refreshing midday activity loved by large teams and mixed-age groups."
  },
  {
    "title": "Evening Bonfire & Folk Entertainment",
    "description": "Wrap up your outing with a cozy bonfire surrounded by folk music, dholki songs, and storytelling. The relaxed atmosphere encourages conversations, laughter, and shared memories under starlit skies."
  },
  {
    "title": "Corporate Pavilion & Meeting Zones",
    "description": "Some agro-tourism farms offer shaded pavilions or outdoor halls for team briefings, workshops, or recognition ceremonies—allowing for a blend of business and leisure in a rustic setting."
  },
  {
    "title": "Customizable Corporate Packages",
    "description": "Choose from half-day, full-day, or overnight stay options with inclusions like welcome drinks, organic meals, team games, DJ nights, farm tours, and accommodation. Ideal for HR teams planning a seamless, all-in-one rural retreat."
  }
],




"services": [
  {
    "name": "Corporate Day Outings Near Pune",
    "description": "Anand Krushi Paryatan Kendra offers the perfect setting for corporate day outings near Pune. Located amidst serene farmlands and mango orchards, it's a place where teams can relax, rejuvenate, and reconnect through rural experiences, nature-based activities, and delicious farm-fresh food — all within a few hours’ drive from the city."
  },
  {
    "name": "Team-Building Resorts in Morachi Chincholi",
    "description": "Our property is designed with team-building in mind. Open green spaces, rope activities, and group games like tug-of-war, obstacle courses, and farming competitions make it one of the most engaging team-building resorts in the Morachi Chincholi region."
  },
  {
    "name": "Nature Outing for Office Teams",
    "description": "Swap your boardroom for a mango orchard. Nature outings at our farm resort offer a peaceful break for teams—ideal for stress relief, creativity, and open conversation. Strolls, birdwatching, farm tours, and bonfire chats encourage bonding away from office pressure."
  },
  {
    "name": "Conference Plus Picnic Spots",
    "description": "Combine business with leisure! Anand Krushi Paryatan Kendra offers space for informal meetings or team discussions, followed by farm-fresh meals and recreational activities. It’s ideal for short strategy sessions or annual meet-ups that don’t feel like work."
  },
  {
    "name": "Activities for Employee Engagement",
    "description": "Boost morale and build stronger connections with curated activities like farming challenges, team races, cultural performances, pottery, and rural games. These low-pressure yet interactive experiences create a fun and inclusive environment for all employees."
  },
  {
    "name": "One-Day Corporate Picnic Destinations",
    "description": "If you're looking for a refreshing one-day getaway from Pune for your team, this is it. Spend the day enjoying traditional food, nature trails, group games, and farm activities. Our packages are designed to balance fun, food, and flexibility for companies of all sizes."
  },
  {
    "name": "Farm Retreats for Corporates",
    "description": "Our corporate farm retreats blend relaxation with rustic charm. With wide-open spaces, fresh air, and nourishing food, they serve as an ideal stress-buster. From junior staff to executives, everyone finds value in reconnecting with nature and disconnecting from devices."
  },
  {
    "name": "Rural Team Outing Packages",
    "description": "Tailored group packages include welcome drinks, rural meals, bullock cart rides, team-building games, guided farm tours, and fun sessions like mud farming or water games. These rural outings are perfect for breaking the usual office routine in a cost-effective way."
  },
  {
    "name": "Adventure Games for Corporates",
    "description": "Add a dose of adrenaline to your day! Activities like rope climbing, Burma bridge, ladder walk, and net crossing are safe, supervised, and perfect for building trust, focus, and collaboration among team members while having loads of fun."
  },
  {
    "name": "Stress-Relief Nature Outings",
    "description": "Help your team decompress with a nature outing that includes birdwatching, quiet spots for mindfulness, greenery, and open skies. Perfect for mental wellness days or as a reward trip to reduce workplace burnout."
  },
  {
    "name": "Workshops and Training Venues in Nature",
    "description": "Looking to conduct a training session or motivational talk? Our semi-open training areas in a quiet rural setting are ideal for workshops, CSR events, or soft-skill programs, offering a break from the usual indoor training venues."
  },
  {
    "name": "Fun Corporate Getaways",
    "description": "Reward your employees with a day filled with laughter, games, traditional food, and nature walks. Whether it’s a team celebration or an annual retreat, Anand Krushi Paryatan Kendra ensures a joyful and well-organized outing for all teams."
  },
  {
    "name": "Budget-Friendly Office Trips",
    "description": "We offer custom corporate day outing packages that suit every budget without compromising on experience. Our all-inclusive options cover food, activities, games, and amenities—making planning easy for HR teams or group leaders."
  },
  {
    "name": "Outdoor Meeting Spots Near Pune",
    "description": "Forget boardrooms! Hold your team huddle or brainstorming session in the open fields under a tree or by the farm pavilion. The fresh air and change in scenery often spark creativity and deeper conversations."
  },
  {
    "name": "Farm Lunch and Activities for Teams",
    "description": "Nothing builds bonds like good food and fun. Enjoy a Maharashtrian thali prepared from freshly harvested ingredients followed by relaxed activities like bullock cart rides, local games, and photo ops amidst peacocks and nature trails."
  }
],
"tableData": [
  ["Corporate Day Outings Near Pune", "- Team-Building Resorts in Morachi Chincholi"],
  ["Nature Outing for Office Teams", "- Conference Plus Picnic Spots"],
  ["Activities for Employee Engagement", "- One-Day Corporate Picnic Destinations"],
  ["Farm Retreats for Corporates", "- Rural Team Outing Packages"],
  ["Adventure Games for Corporates", "- Stress-Relief Nature Outings"],
  ["Workshops and Training Venues in Nature", "- Fun Corporate Getaways"],
  ["Budget-Friendly Office Trips", "- Outdoor Meeting Spots Near Pune"],
  ["Farm Lunch and Activities for Teams", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Perfect Blend of Work and Leisure",
    "WhyChoosedescription": "Morachi Chincholi offers the ideal balance for corporate outings—peaceful rural surroundings combined with engaging activities. It's a refreshing break from office routines, allowing teams to relax and bond in a natural environment."
  },
  {
    "WhyChooseheading": "Team-Building Activities",
    "WhyChoosedescription": "Agro-tourism centers like Anand Krushi Paryatan Kendra provide customized team-building games, outdoor challenges, and group exercises that encourage communication, collaboration, and leadership among team members."
  },
  {
    "WhyChooseheading": "Outdoor Meeting and Seminar Facilities",
    "WhyChoosedescription": "Many venues in Morachi Chincholi offer open-air or semi-indoor spaces equipped for meetings, training sessions, and presentations—perfect for companies seeking a productive yet informal setting away from city distractions."
  },
  {
    "WhyChooseheading": "Recreational Activities for Teams",
    "WhyChoosedescription": "Corporate groups can enjoy activities such as tractor rides, zip-lining, archery, rain dance, and sports like cricket and volleyball. These fun-filled experiences help in stress relief and foster team camaraderie."
  },
  {
    "WhyChooseheading": "Traditional Food and Rural Hospitality",
    "WhyChoosedescription": "Enjoy authentic Maharashtrian meals made from fresh, local ingredients. The warm hospitality, combined with home-style cooking, gives employees a memorable culinary and cultural experience."
  },
  {
    "WhyChooseheading": "Accessible and Affordable for Groups",
    "WhyChoosedescription": "Just 50–60 km from Pune, Morachi Chincholi is easily reachable for a day trip. Group packages for corporates are cost-effective, often including meals, activities, and space rentals, making it an efficient and enjoyable outing option."
  }
]






















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi suitable for corporate outings?',
    answer: 'Yes! Morachi Chincholi is an ideal destination for corporate outings, offering team-building activities, outdoor games, and peaceful natural surroundings perfect for employee engagement.',
  },
  {
    id: 'FAQ2',
    question: 'What team-building activities are available?',
    answer: 'Activities include obstacle courses, tug-of-war, group farming tasks, bullock cart races, trust-building games, and adventure elements like zip-lining (at select resorts).',
  },
  {
    id: 'FAQ3',
    question: 'Are customized packages available for corporate groups?',
    answer: 'Yes, agro-tourism centers offer tailored corporate packages with meals, activities, meeting spaces, and entertainment based on group size and schedule.',
  },
  {
    id: 'FAQ4',
    question: 'Can corporate events be organized for a full day?',
    answer: 'Absolutely. Full-day events with breakfast, lunch, snacks, activities, and wrap-up meetings are commonly hosted for teams from Pune and nearby.',
  },
  {
    id: 'FAQ5',
    question: 'Is overnight accommodation available for corporate teams?',
    answer: 'Yes. Many resorts offer dormitories, cottages, and tent stays suitable for corporate overnight trips, especially during seasonal events.',
  },
  {
    id: 'FAQ6',
    question: 'Is transportation available for corporate groups?',
    answer: 'Some venues provide or help coordinate transportation via buses or private cabs from Pune for convenience and group comfort.',
  },
  {
    id: 'FAQ7',
    question: 'Are indoor meeting facilities available?',
    answer: 'Yes, basic indoor halls or covered sheds with seating, sound systems, and whiteboards are available for team discussions and presentations.',
  },
  {
    id: 'FAQ8',
    question: 'What is included in a typical corporate outing package?',
    answer: 'Packages usually include meals (breakfast, lunch, tea), use of venue, team activities, and optional cultural shows or guided tours.',
  },
  {
    id: 'FAQ9',
    question: 'How far is Morachi Chincholi from Pune for a day trip?',
    answer: 'It is approximately 60–65 km from Pune, making it an ideal destination for one-day corporate getaways.',
  },
  {
    id: 'FAQ10',
    question: 'How can we book a corporate outing in Morachi Chincholi?',
    answer: 'You can contact agro-tourism venues like Anand Krushi Paryatan Kendra directly via phone or email to inquire and book custom packages.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Khare, HR Head, Pune',
    feedback: "Our team had an amazing outing at Morachi Chincholi. The bonding games, rural setup, and fresh food brought a welcome break from office life. Highly recommended!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Leena Patwardhan, IT Manager, Pimpri',
    feedback: "The peaceful environment and well-managed activities made our team outing a big success. Everything from travel to food was handled smoothly by the hosts.",
    rating: 5,
  },
];

























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Outing Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/corporate-outing-morachi-chincholi.jpg",
  "description": "Plan corporate day outings near Pune at Morachi Chincholi with team-building resorts, nature outings, picnic spots, adventure games, workshops, farm retreats, and outdoor meeting venues for employee engagement and stress relief.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.5",
    "ratingCount": "875"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/corporate-outing"
  }
};



    return (
        <div>
<Helmet>
  <title>Corporate Outing Morachi Chincholi Pune | Team Building & Nature Retreats</title>
  <meta 
    name="description" 
    content="Organize corporate outings at Morachi Chincholi near Pune featuring team-building resorts, adventure games, picnic spots, workshops, farm retreats, and outdoor meeting spaces for office teams." 
  />
  <meta 
    name="keywords" 
    content="Corporate day outings near Pune, Team-building resorts in Morachi Chincholi, Nature outing for office teams, Conference plus picnic spots, Activities for employee engagement, One-day corporate picnic destinations, Farm retreats for corporates, Rural team outing packages, Adventure games for corporates, Stress-relief nature outings, Workshops and training venues in nature, Fun corporate getaways, Budget-friendly office trips, Outdoor meeting spots near Pune, Farm lunch and activities for teams" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporateoutingmorachichincholi;